import { render, staticRenderFns } from "./SignUpSuccess.vue?vue&type=template&id=e90f2fa4&scoped=true&"
import script from "./SignUpSuccess.vue?vue&type=script&lang=js&"
export * from "./SignUpSuccess.vue?vue&type=script&lang=js&"
import style0 from "./SignUpSuccess.vue?vue&type=style&index=0&id=e90f2fa4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90f2fa4",
  null
  
)

export default component.exports